import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=063284dc&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=063284dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063284dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('063284dc')) {
      api.createRecord('063284dc', component.options)
    } else {
      api.reload('063284dc', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=063284dc&scoped=true&", function () {
      api.rerender('063284dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2CJtNuX5QFyoz/JS/teamMember.vue"
export default component.exports